import { Component, Input,SimpleChanges, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ITableColumn, TableLinkTargets, TableColumnType } from '../../../controls/table/table-column';
import { ITableFilter } from '../../../controls/table/table-filter';
import { IUser } from '../../../../shared/models/user';
import { Subscription, takeWhile } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../shared/services/auth.service';
import { UserUtility } from '../../../../shared/utilities/user-utility';
import { ICommitteePublishedDocumentDto } from '../../shared/models/committee-published-document';
import { DocumentService } from '../../shared/services/document.service';
import { IApiResponse } from '../../../../shared/models/api-response';

@Component({
    selector: 'app-committee-details-publication',
    templateUrl: './committee-details-publication.component.html',
    styleUrl: './committee-details-publication.component.scss',
    standalone: false
})
export class CommitteeDetailsPublicationComponent implements OnInit, OnChanges, OnDestroy {
  @Input() committeeCode: string | null = null;
  publications: ICommitteePublishedDocumentDto[] | null = null;
  tableData: ICommitteePublishedDocumentDto[] = [];
  tableColumns: ITableColumn<ICommitteePublishedDocumentDto>[] = [];
  tableFilters: ITableFilter[] = [];
  loading: boolean = true;
  currentUser: IUser | null = null;
  subscriptions: Subscription = new Subscription();

  constructor(
    private _authService: AuthService,
    private _documentService: DocumentService
  ) {
  }

  ngOnInit(): void {
    const userSubscription = this._authService.currentUserSubject
    .pipe(
      takeWhile(() => this.currentUser == null)
    )
    .subscribe(user => {
      if (user) {
        this.currentUser = user;
        this.initializeTableColumns();
        this.initialize();
      }
    });

    this.subscriptions.add(userSubscription);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if(changes['committeeCode'] && changes['committeeCode'].currentValue && !changes['committeeCode'].firstChange) {
      this.committeeCode = changes['committeeCode'].currentValue;
      this.initialize();
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  initialize() {

    if(this.currentUser && this.committeeCode){
      this.getCommitteePublishedDocuments();
    }
  }

  setTableData() {
    if(this.publications){
      this.tableData = this.publications;
    }
  }

  getCommitteePublishedDocuments() {

    const committeeCode = this.committeeCode;
    if (!committeeCode) {
      return;
    }

    this.loading = true;

    const SIMDocumentSearchSubscription = this._documentService
      .getPublishedDocumentsByCommittee(committeeCode)
      .subscribe({
        next: (response: IApiResponse<ICommitteePublishedDocumentDto[]>)  => {
          if (response.success && response.content) {
            this.publications = response.content ?? [];
            this.setTableData();
          }
          this.loading = false;
        },
        error: _ => {
          this.publications = [];
          this.setTableData();
          this.loading = false;
          console.log('Error fetching published documents for committee:', committeeCode);
        }

      });

    this.subscriptions.add(SIMDocumentSearchSubscription);
  }

  initializeTableColumns() {
    const isMOP = this.currentUser && UserUtility.isMemberOfPublicOnly(this.currentUser);
    const isInternalUser = UserUtility.isInternalUser(this.currentUser);

    let columns : ITableColumn<ICommitteePublishedDocumentDto>[] =
    [
      // For Designation column:
      // MoP users see read only text
      // Internal users see a link SIM
      // Committee members see a link to the document in the Standards Library page
      {
        name: 'designation',
        displayName: 'Designation',
        type: isMOP ? TableColumnType.string :
              isInternalUser ? TableColumnType.link :
                TableColumnType.routerLink,
        isSortable: true,
        getLink: (row: ICommitteePublishedDocumentDto) => {
          return isInternalUser ?
            `${environment.internalSIMUrl}${row.uri}` :
            `/sa-library/${row.uri}`;
        },
        linkTarget: isInternalUser ? TableLinkTargets.blank : TableLinkTargets.self,
        headerWidth: '80px'
      },
      {
        name: 'title',
        displayName: 'Title',
        isSortable: true,
        headerWidth: '65%'
      },
    ];

    this.tableColumns = columns;
  }
}
